import Flashphoner from "@flashphoner/websdk/flashphoner.js";

var flashSESSION_STATUS = Flashphoner.constants.SESSION_STATUS;
//var flashSTREAM_STATUS = Flashphoner.constants.STREAM_STATUS;
var flashSession = {};
var flashStream = {};

export const apiFlashphoner = {
  initStream() {
    Flashphoner.init({});
  },
  connectPublish(token, evento, canal = "1", videoInput, preview = true) {
    var thisCall = this;
    flashSession[evento._id + "_" + canal] = Flashphoner.createSession({
      urlServer: evento.servidor,
      custom: { token: token }
    }).on(flashSESSION_STATUS.ESTABLISHED, function(session) {
      thisCall.publishStream(token, session, evento, canal, videoInput, preview);
    });
  },
  connectPlay(token, evento, canal = "1") {
    var thisCall = this;
    flashSession[evento._id + "_" + canal] = Flashphoner.createSession({
      urlServer: evento.servidor,
      custom: { token: token }
    }).on(flashSESSION_STATUS.ESTABLISHED, function() {
      thisCall.playStream(token, evento, canal);
    });
  },
  //constraints.video.type = "screen";
  publishStream(token, session, evento, canal = "1", videoInput, preview) {
    var optionsStream = {
      name: evento._id + "_" + canal,
      //remoteVideo: document.getElementById("flashPublishVideo"),
      constraints: {
        video: {
          withoutExtension: true,
          frameRate: 30
        }
      },
      custom: { token: token }
    };

    //width: 640,
    //height: 480,

    if (preview) {
      optionsStream.display = document.getElementById("publishFlash");
    } else {
      optionsStream.display = document.getElementById("publishFlash");
    }

    if (preview) {
      var elementCanvasLive = document.getElementById("canvasLive");
      //var ctxLive = elementCanvasLive.getContext("2d");
      //optionsStream.constraints.customStream = this.createCanvasStream().captureStream();
      optionsStream.constraints.customStream = elementCanvasLive.captureStream();
      optionsStream.cacheLocalResources = true;
    } else {
      if (videoInput == "screen") {
        optionsStream.constraints.video.type = videoInput;
      } else {
        optionsStream.constraints.video.deviceId = videoInput;
      }
    }

    console.log(optionsStream);

    flashStream[evento._id + "_" + canal] = session.createStream(optionsStream);
    flashStream[evento._id + "_" + canal].publish();
  },
  playStream(token, evento, canal) {
    flashSession[evento._id + "_" + canal]
      .createStream({
        name: evento._id + "_" + canal,
        display: document.getElementById("playFlash"),
        remoteVideo: document.getElementById("flashPlayVideo"),
        receiveAudio: false,
        custom: { token: token }
      })
      .play();
  },
  stopStream(evento, canal) {
    flashStream[evento._id + "_" + canal].stop();
  }
  /*
  createCanvasStream() {
    var ctx = canvas.getContext("2d");
    ctx.font = "30px Arial";
    ctx.fillStyle = "red";
    ctx.fillRect(0, 0, 320, 180);
    ctx.strokeStyle = "black";
    ctx.fillStyle = "green";

    (function loop() {
      ctx.fillText("Hello World", 10, 50);
      setTimeout(loop, 1000 / 30); // drawing at 30fps
    })();

    return canvas.captureStream(30);
  }*/
};
